import { useContext, useEffect, useState } from 'react';
import { getCartPageData } from '../api/cart-page';
import { CartContext } from '../contexts/CartContext';
import { DISPLAY_LANG } from '../config';
import Loading from "../components/loading";
import CartList from '../components/cart-page/CartList';
import '../stylesheets/cart.css';

export default function CartPage() {
    const [cartEmptyData, setCartEmptyData] = useState(null);
    const [cartPageData, setCartPageData] = useState(null);
    const { orders, loading, cursorLoad } = useContext(CartContext);

    useEffect(() => {
        const loadingData = async () => {
            const data = await getCartPageData();
            setCartEmptyData(data.cartEmptyMessage);
            setCartPageData(data.cartPage);
        };

        loadingData();
        window.scrollTo(0, 0);
    }, []);

    if (loading) {
        return <Loading />;
    }

    return cartEmptyData && cartPageData && (
        <div className="CartPage wrapper" style={{ cursor: cursorLoad ? 'wait' : '' }}>
            <div className="content">
                {!orders.length && <p className='cart-empty-message'>{cartEmptyData[DISPLAY_LANG]}</p>}
                {cartPageData && !!orders.length && <CartList pagedata={cartPageData} />}
            </div>
        </div>
    )
}
